module.exports = __webpack_public_path__ + "static/media/no_user_service_old.4d94424a.png";